import { createAction } from '@reduxjs/toolkit';

export const ADD_STORING_PHONE_NUMBER = 'phone/addStoringPhoneNumber';

export const addStoringPhoneNumber = createAction(
    ADD_STORING_PHONE_NUMBER,
    ({ phone }: {phone: string}) => ({ payload: { phone } }),
);
